"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFault = exports.getFatalContext = exports.meterFatalsFromResponse = exports.emitCountMetrics = exports.emitLatencyMetrics = exports.emitCountMetricV2 = exports.emitLatencyMetricV2 = exports.meterFatals = exports.generateCountersMetricsArrayForTestingOnly = exports.getEventNamePrefix = exports.isRobot = exports.isInternal = exports.meterStatusCode = void 0;
const constants_1 = require("../../constants");
const isomorphic_1 = require("../../isomorphic");
const metrics_1 = require("../../metrics");
const error_1 = require("../../models/error");
const state_1 = require("../../state");
const registry_1 = require("../../state/registry");
const window_1 = require("../window");
const INTERNAL_IP_FIREWALL_VALUE = 'firewall';
const INTERNAL_IP_RFC1918_VALUE = 'rfc1918';
const INTERNAL_IP_LOOPBACK_VALUE = 'loopback';
const BOT_TRAFFIC_POLICY_IDS = ['RM-BOT', 'RM-HIGH', 'RD-MC', 'FTL-BOT'];
const meterStatusCode = (context) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const tenant = (_a = context.tenant) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    const recordCounters = (0, metrics_1.curriedRecordCounters)();
    const methodName = context.methodName;
    const statusCode = `${context.statusCode.toString().charAt(0)}XX`;
    const counters = [
        {
            name: methodName,
            eventName: `${constants_1.ALL}:StatusCode:${statusCode}`,
            value: 1,
            unit: 'Count'
        }
    ];
    if (tenant) {
        counters.push({ name: methodName, eventName: `${tenant}:StatusCode:${statusCode}`, value: 1, unit: 'Count' });
    }
    return recordCounters(counters);
});
exports.meterStatusCode = meterStatusCode;
function isInternal(ipClasses) {
    if (ipClasses.length === 0) {
        return false;
    }
    const splitIpClasses = ipClasses.split(/\s*,\s*/);
    for (let i = 0; i < splitIpClasses.length; i++) {
        const currentIpValue = splitIpClasses[i];
        switch (currentIpValue.toLowerCase()) {
            case INTERNAL_IP_FIREWALL_VALUE:
            case INTERNAL_IP_RFC1918_VALUE:
            case INTERNAL_IP_LOOPBACK_VALUE:
                return true;
            default:
                break;
        }
    }
    return false;
}
exports.isInternal = isInternal;
const isRobot = (trafficPolicies = '') => {
    return trafficPolicies.split(',').some((trafficPolicy) => BOT_TRAFFIC_POLICY_IDS.includes(trafficPolicy.trim()));
};
exports.isRobot = isRobot;
const getEventNamePrefix = (shoppingPortalState) => {
    return shoppingPortalState
        ? `${(0, exports.isRobot)(shoppingPortalState.trafficPolicies) ? `${constants_1.ROBOT}:` : ''}${isInternal(shoppingPortalState.internalIpClass) ? `${constants_1.INTERNAL}:` : ''}`
        : '';
};
exports.getEventNamePrefix = getEventNamePrefix;
const generateCountersMetricsArray = (methodName, shoppingPortalState, metricName, tenant, success, fault, error) => {
    const counters = [
        {
            name: methodName,
            eventName: `${(0, exports.getEventNamePrefix)(shoppingPortalState)}${constants_1.ALL}:Success:${metricName}`,
            value: success,
            unit: 'Count'
        },
        {
            name: methodName,
            eventName: `${(0, exports.getEventNamePrefix)(shoppingPortalState)}${constants_1.ALL}:Fault:${metricName}`,
            value: fault,
            unit: 'Count'
        },
        {
            name: methodName,
            eventName: `${(0, exports.getEventNamePrefix)(shoppingPortalState)}${constants_1.ALL}:Error:${metricName}`,
            value: error,
            unit: 'Count'
        }
    ];
    if (tenant) {
        counters.push({
            name: methodName,
            eventName: `${(0, exports.getEventNamePrefix)(shoppingPortalState)}${tenant}:Success:${metricName}`,
            value: success,
            unit: 'Count'
        }, {
            name: methodName,
            eventName: `${(0, exports.getEventNamePrefix)(shoppingPortalState)}${tenant}:Fault:${metricName}`,
            value: fault,
            unit: 'Count'
        }, {
            name: methodName,
            eventName: `${(0, exports.getEventNamePrefix)(shoppingPortalState)}${tenant}:Error:${metricName}`,
            value: error,
            unit: 'Count'
        });
    }
    return counters;
};
exports.generateCountersMetricsArrayForTestingOnly = { generateCountersMetricsArray };
const meterFatals = (context) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const tenant = (_b = context.tenant) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    const { methodName, metricName } = context;
    const success = context.success ? 1 : 0;
    const fault = context.fault ? 1 : 0;
    const error = context.error ? 1 : 0;
    let shoppingPortalState;
    if ((0, window_1.isClientSide)()) {
        shoppingPortalState = window.__MONERA_SHOPPING_PORTAL_STORE__;
        if (!shoppingPortalState) {
            const counters = generateCountersMetricsArray(methodName, shoppingPortalState, metricName, tenant, success, fault, error);
            isomorphic_1.LOGGER.info(`Service call stats = success: ${success}, fault: ${fault}, error: ${error}, metricName: ${metricName}, tenant: ${tenant}`);
            const recordCounters = (0, metrics_1.curriedRecordCounters)();
            return recordCounters(counters);
        }
    }
    else {
        shoppingPortalState = registry_1.registry.getStore(state_1.shoppingPortalStore, context.requestId).getState();
    }
    const ipClasses = shoppingPortalState.internalIpClass;
    const internal = isInternal(ipClasses);
    const counters = generateCountersMetricsArray(methodName, shoppingPortalState, metricName, tenant, success, fault, error);
    isomorphic_1.LOGGER.info(`Service call stats = success: ${success}, fault: ${fault}, error: ${error}, metricName: ${metricName}, internal: ${internal}, tenant: ${tenant}`);
    const recordCounters = (0, metrics_1.curriedRecordCounters)();
    return recordCounters(counters);
});
exports.meterFatals = meterFatals;
const emitLatencyMetricV2 = (methodName, metricName, value, tenant) => {
    return (0, exports.emitLatencyMetrics)(methodName, metricName, value, '', tenant);
};
exports.emitLatencyMetricV2 = emitLatencyMetricV2;
const emitCountMetricV2 = (methodName, metricName, value, tenant) => {
    return (0, exports.emitCountMetrics)(methodName, metricName, value, '', tenant);
};
exports.emitCountMetricV2 = emitCountMetricV2;
const emitLatencyMetrics = (methodName, metricName, value, _requestId, tenant) => {
    const recordTimers = (0, metrics_1.curriedRecordTimers)();
    const timers = [
        {
            name: methodName,
            eventName: 'ALL' + ':Latency:' + metricName,
            value,
            unit: 'Milliseconds'
        }
    ];
    if (tenant) {
        timers.push({ name: methodName, eventName: tenant + ':Latency:' + metricName, value, unit: 'Milliseconds' });
    }
    return recordTimers(timers);
};
exports.emitLatencyMetrics = emitLatencyMetrics;
const emitCountMetrics = (methodName, metricName, value, _requestId, tenant) => {
    const recordCounter = (0, metrics_1.curriedRecordCounters)();
    const counters = [
        {
            name: methodName,
            eventName: `${constants_1.ALL}:${metricName}`,
            value,
            unit: 'Count'
        }
    ];
    if (tenant) {
        counters.push({ name: methodName, eventName: `${tenant.toUpperCase()}:${metricName}`, value, unit: 'Count' });
    }
    return recordCounter(counters);
};
exports.emitCountMetrics = emitCountMetrics;
const meterFatalsFromResponse = (response, context) => {
    const { methodName, metricName } = context;
    const fatalContext = (0, exports.getFatalContext)(response);
    if (fatalContext.fault) {
        isomorphic_1.LOGGER.error(`${methodName} ${metricName} faulted [${response === null || response === void 0 ? void 0 : response.name}] ${response === null || response === void 0 ? void 0 : response.message}`);
    }
    else if (fatalContext.error) {
        isomorphic_1.LOGGER.error(`${methodName} ${metricName} errored [${response === null || response === void 0 ? void 0 : response.name}] ${response === null || response === void 0 ? void 0 : response.message}`);
    }
    return (0, exports.meterFatals)(Object.assign(Object.assign({}, context), fatalContext));
};
exports.meterFatalsFromResponse = meterFatalsFromResponse;
const getFatalContext = (response) => {
    let success = false;
    let fault = false;
    let error = false;
    if (!response) {
        fault = true;
    }
    else if ((0, error_1.isError)(response)) {
        error = !(0, exports.isFault)(response);
        fault = (0, exports.isFault)(response);
    }
    else {
        success = true;
    }
    return {
        success,
        error,
        fault
    };
};
exports.getFatalContext = getFatalContext;
const isFault = (error) => {
    if (error === undefined || error === null) {
        return true;
    }
    const statusCode = (0, error_1.getStatusCodeFromErrorType)(error.name);
    const statusCodePrefix = statusCode.toString().charAt(0);
    return statusCodePrefix === '5';
};
exports.isFault = isFault;
